<template>
  <!-- header -->
  <v-layout row wrap mb-5 align-items-center>
    <v-flex xs12 md5>
      <h3 class="font-weight-thin display-2 text-xs-center text-md-left">
        {{ headerTitle }}
      </h3>
    </v-flex>

    <v-flex xs12 md3 px-5>
      <slot name="addNew">
        <v-btn block color="primary" v-if="addNewItem" @click="addNewItem"
          >Add New</v-btn
        >
      </slot>
    </v-flex>

    <v-flex xs12 md4 px-5>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        @input="updateSearchModel"
        single-line
        hide-details
      ></v-text-field>
    </v-flex>
  </v-layout>
  <!--/header -->
</template>

<script>
export default {
  props: {
    headerTitle: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ""
    },
    addNewItem: {
      type: Function
    }
  },
  data: () => ({
    search: ""
  }),
  mounted() {
    this.search = this.value;
  },
  methods: {
    updateSearchModel() {
      this.$emit("input", this.search);
    }
  }
};
</script>
